webpackJsonp([257927051873212],{

/***/ 1591:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"slug":"/it/multires/","langKey":"it"}}

/***/ })

});


// WEBPACK FOOTER //
// path---it-multires-edbf149fa10113ec19a6.js